import React from 'react';
import { Col, Row, Card } from 'react-bootstrap';
import './relatedArticle.scss';
import { getInsightTabPath, getRelatedArticles } from '../../../../common/utils';
import { useNavigate } from 'react-router-dom';
import { SectionWrapper } from '../../../../theme/layouts/MainLayout';
import { useAppContext } from '../../../../common/context';

const getCat = name => {
  if(name === 'whats-news'){
    return 'whats'
  } else if(name === 'intel-ideas'){
    return 'intel'
  } else {
    return 'success'
  }
}
const RelatedArticle = ({ relatedArticles,module }) => {
  const navigation = useNavigate();
  const {insightTab, tabHandler} = useAppContext();
  const insightPath = getInsightTabPath(insightTab);
  if(!relatedArticles){
    return <></>
  }
  
  const articleItems = getRelatedArticles(module,relatedArticles.links);
  const getPic = (card) => card.banner?card.banner: '/images/insights/insight-card-thumb.png';

  const clickHandler = (str) => { 
    const {slug,category} = str;
    const url = `/${insightPath}${slug}`;
    tabHandler(getCat(category));
    navigation(url);
  }

  return (
    <SectionWrapper  bg={'#FFFFFF'}>
      <section className='related-article-section'>
        <Row>
          <Col md={12} sm={12}>
            <div className='article-title'>Related articles</div>
          </Col>
        </Row>
        <Row className='related-article-container'>
          {articleItems && Array.isArray(articleItems) && articleItems.map((card) => (
            <Col className="article-card-item" key={card.id} md={4} sm={12} onClick={() => clickHandler(card)}>
              
              <Card className='cart-style story-list-image w-100'>
              <div className="related-card-benner-conatiner">
                <Card.Img variant="top" src={getPic(card)} onContextMenu={(e) => e.preventDefault()}/>
              </div>
                <Card.Body className='p-0'>
                  <Card.Title className='article-cart-title'>{card.eyebrowText || ""}</Card.Title>
                  <Card.Text className='article-cart-text'>
                    {card.title || ""}
                  </Card.Text>
                </Card.Body>
              </Card>
             
            </Col>
          ))}
        </Row>
      </section>
    </SectionWrapper>
  )
}

export default React.memo(RelatedArticle);